
    function findUserMsgStartIndex(original) 
    {
        let start = 0;
        if (original.toLowerCase().includes("usrmsg") 
            || original.toLowerCase().includes("usermsg") 
            || original.toLowerCase().includes("usermessage=|"))  /* more specific on this one incase usermessage appears in exception message */
        {
            start = original.indexOf("|"); // -1 if not found
        }
        return start;
    };

    function findUserMsgEndIndex(original, start) 
    {
        let end = 0;
        if (start > 5) 
        {
            end = original.indexOf("|", start + 2);  
        }
        return end;
    };

export function ExtractUserMsgFromInvalidResponse(original) {

        var start = 0;
        var end = 0;
        let part = "";
        original = original.trim();

        start = findUserMsgStartIndex(original);
        end = findUserMsgEndIndex(original, start);

        if (start > 5 &&  end > start && end < original.length) 
        {
            part = original.slice(start + 1, end);
        }

        return part;
}
export function ExtractConsoleMsgFromInvalidResponse(original) 
{
        var start = 0;
        var end = 0;
        let consolem = "";
        original = original.trim();

        start = findUserMsgStartIndex(original); /* need the start of the piped string to find the end */
        end = findUserMsgEndIndex(original, start);

        if (start > 5 && end > start && end < original.length) 
        {
            consolem = original.substring (end+1);
        }

        return consolem.trim();
}

// 
// errMsg = ExtractMsgsFromInvalidResponse (save, 
//                            "Unfortunately, we are unable to save your changes. Please contact our <a href='https://www.eadmissions.org.uk/support/' target='_blank' style='text-decoration:underline'>technical support team</a> if this problem is persistent.", 
//                             "Problem saving: ")
export function ExtractMsgsFromInvalidResponse (responseData, defaultMsg, prefixMsg)
{  
    let errMsg = defaultMsg;
    if (typeof(responseData.message) !== "undefined")
    {
        let message = responseData.message;
        let extract = ExtractUserMsgFromInvalidResponse(message);
        if (extract !== "" && extract.length > 0)
        {
            errMsg = extract;
                            
            extract = "";
            extract = ExtractConsoleMsgFromInvalidResponse(message);
            if (extract !== "" && extract.length > 0)
            {
                 message = extract;
            }
                        
            console.log (prefixMsg + "[" + errMsg + "], inner exception: [" + message + "]");
        }
    }
    
    return errMsg;
}
